import { render, staticRenderFns } from "./historyReport.vue?vue&type=template&id=07ff8d86&scoped=true&"
import script from "./historyReport.vue?vue&type=script&lang=js&"
export * from "./historyReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ff8d86",
  null
  
)

export default component.exports